var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-start mb-1"},[_c('label',{staticClass:"block text-secondary text-sm font-medium leading-4 uppercase",attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }